import React from 'react';

import MaxBraun from './components/max-braun/main';

const App = () => {
  return (
    <MaxBraun />
  );
};

export default App;
